<template>
  <div>
    <search-bar :hasTitle="false" :backgroundColorGray="false"></search-bar>
    <!-- <section class="global-search">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <div class="search-bar clearfix">
              <input
                type="text"
                class="form-control"
                placeholder="Busque pelo produto, filtro ou equivalência"
              >
              <button type="button" class="btn btn-primary btn-search">
                <i class="icon-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>-->

    <section class="section-gray section-contact">
      <div class="container">
        <div class="contact">
          <div class="contact-info">
            <h1>Quer falar com a gente? Entre em contato</h1>
            <h2 class="title">Endereço</h2>
            <div>
              Av Dr. Mauro Lindemberg Monteiro 185 – GP 8
              <br>Jd Santa Fé / Osasco, SP - CEP 06278-010
            </div>
            <h2 class="title">Contato</h2>
            <div>Email: contato@japanparts.com.br</div>
            <div>Telefone: (11) 3670-4400</div>
          </div>
          <!-- <div class="map">
            <iframe
              src="./Contact_files/embed.html"
              width="1100"
              height="500"
              frameborder="0"
              style="border:0"
              allowfullscreen
            ></iframe>
          </div>-->
          <div class="map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3659.380778522361!2d-46.776434685590466!3d-23.482790484721974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cefe9d9c236c11%3A0x982d4fccaaa12e5a!2sAv.%20Dr.%20Mauro%20Lindemberg%20Monteiro%2C%20185%20-%20Santa%20F%C3%A9%2C%20Osasco%20-%20SP%2C%2006278-010!5e0!3m2!1spt-BR!2sbr!4v1605223200794!5m2!1spt-BR!2sbr"
              width="1100"
              height="500"
              frameborder="0"
              style="border:0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>

    <section class="contact-form">
      <div class="container">
        <h1 class="mb-5">Dúvida técnica de produto ou instalação?</h1>
        <div class="row">
          <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                v-model="data.name"
                v-validate="'required'"
                placeholder="Nome"
              >
            </div>
            <div class="form-group">
              <input
                type="email"
                class="form-control"
                v-model="data.email"
                v-validate="'required|email'"
                placeholder="Email"
              >
            </div>
            <div class="form-group">
              <label for="category">Categoria</label>
              <div class="custom-select-box form-control">
                <select id="category">
                  <option>Selecione</option>
                  <option value="vendas">Vendas</option>
                  <option value="dúvidas técnicas">Dúvidas técnicas</option>
                  <option value="garantia">Garantia</option>
                  <option value="sugestões">Sugestões</option>
                  <option value="geral">Geral</option>
                </select>
              </div>

              <!-- <select name v-model="data.subject" class="select">
                <option value>Selecione uma opção</option>
                <option value="vendas">Vendas</option>
                <option value="dúvidas técnicas">Dúvidas técnicas</option>
                <option value="garantia">Garantia</option>
                <option value="sugestões">Sugestões</option>
                <option value="geral">Geral</option>
              </select>-->
              <!-- <input
                type="text"
                class="form-control"
                v-model="data.subject"
                v-validate="'required'"
                placeholder="Assunto"
              >-->
            </div>
            <div class="form-group">
              <textarea
                class="form-control"
                rows="5"
                v-model="data.mesage"
                v-validate="'required'"
                placeholder="Menssagem"
              ></textarea>
            </div>

            <div class="row mt-5">
              <div class="col-md-6 offset-md-3">
                <a href="#" class="btn btn-primary btn-block" @click.prevent="validate">Enviar</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="diagonal-line"></div>
  </div>
</template>

<script>
import SweetAlert from "@/components/EspressoAux.vue";
import ContactAPI from "@/api/contact";

import SearchBar from "@/components/SearchBar.vue";

export default {
  components: { SearchBar },
  data() {
    return {
      data: {
        email: "",
        name: "",
        subject: "",
        mesage: ""
      }
    };
  },
  mounted() {
    let ckeditor = document.createElement("script");
    ckeditor.setAttribute("src", "../../static/js/script.js");
    document.head.appendChild(ckeditor);
  },
  methods: {
    async validate() {
      const isValid = await this.$validator.validate();
      if (isValid) {
        this.getSubject();
      } else {
        SweetAlert.showFailModal("Preencha todos os campos corretamente!", "Erro");
      }
    },
    getSubject(){
      let subject = document.getElementsByClassName('select-selected');
      this.data.subject = subject[0].innerText;
      if(!this.data.subject){
        SweetAlert.showFailModal("Preencha todos os campos corretamente!", "Erro");
      }
      else{
        this.send();
      }
    },
    async send() {
      const response = await ContactAPI.sendContact(this.data);
      if (response.success) {
        SweetAlert.showSuccessModal("Informações enviadas com sucesso!");
      } else {
        SweetAlert.showFailModal("Por favor, tente novamente mais tarde!");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-select-box {
  // overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue